import { inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IsConnectedStatus, QuickbooksService, QuickbookStatus } from './quickbooks.service';

@Injectable({ providedIn: 'root' })
export class QuickbooksResolver implements Resolve<QuickbookStatus> {
  private readonly quickbooksService: QuickbooksService = inject(QuickbooksService);

  resolve(): Observable<QuickbookStatus> {
    return this.quickbooksService.status().pipe(
      catchError(() => {
        return of({
          currentStatus: IsConnectedStatus.disconnected,
          email: '',
        });
      }),
    );
  }
}
